
import { useNavigate } from "react-router";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { format, parse, addMonths, subMonths } from "date-fns";

function currentMonth() {
  return new Date().toISOString().slice(0, 7);
}

export function MonthSwitcher({ month }: { month: string }) {
  const navigate = useNavigate();
  const date = parse(month, "yyyy-MM", new Date());
  const isCurrent = month >= currentMonth();

  const go = (m: string) => navigate(`/?month=${m}`);

  return (
    <div className="flex items-center gap-2">
      <button
        type="button"
        aria-label="Previous month"
        onClick={() => go(format(subMonths(date, 1), "yyyy-MM"))}
        className="flex size-11 items-center justify-center rounded-full bg-card text-foreground shadow-sm ring-1 ring-black/[0.05] transition-colors active:bg-muted"
      >
        <ChevronLeft className="size-5" />
      </button>
      <span className="flex h-11 flex-1 items-center justify-center rounded-full bg-card px-4 text-sm font-semibold shadow-sm ring-1 ring-black/[0.05]">
        {format(date, "MMMM yyyy")}
      </span>
      <button
        type="button"
        aria-label="Next month"
        disabled={isCurrent}
        onClick={() => go(format(addMonths(date, 1), "yyyy-MM"))}
        className="flex size-11 items-center justify-center rounded-full bg-card text-foreground shadow-sm ring-1 ring-black/[0.05] transition-colors active:bg-muted disabled:opacity-40"
      >
        <ChevronRight className="size-5" />
      </button>
    </div>
  );
}
